import React, { ReactElement } from "react";
import { TextInput as RATextInput } from "react-admin";

const identity = (value: string) => value;

export const TextInput = (props: any): ReactElement => (
  <RATextInput parse={identity} {...props} />
);
